import { DebugStore } from "./store";

import { createSelector } from "..";

export const debugStore = new DebugStore();

export const useDebugSelector = createSelector(debugStore);

export const placementSelector = (state) => state.placement;
